import React from "react";
import { Chip } from "@heroui/react";
import { Icon } from "@iconify/react";

type MedicalQuestionnaire = {
	psychiatricTreatment: boolean;
	addictionHistory: boolean;
	highBloodSugar: boolean;
	highBloodPressure: boolean;
	hasHeartIssues: boolean;
	hasWeaponLicense: boolean;
	hasTransporters: boolean;
	transporters?: Array<{ id: string; name: string }>;
};

interface MedicalQuestionsProps {
	questionnaire: MedicalQuestionnaire;
}

type Question = {
	key: keyof MedicalQuestionnaire;
	label: string;
};

const questions: Question[] = [
	{ key: "psychiatricTreatment", label: "האם אתה נמצא או היית בטיפול פסיכיאטרי?" },
	{ key: "addictionHistory", label: "האם יש לך היסטוריה של התמכרות?" },
	{ key: "highBloodSugar", label: "האם יש לך רמות סוכר גבוהות בדם?" },
	{ key: "highBloodPressure", label: "האם יש לך לחץ דם גבוה?" },
	{ key: "hasHeartIssues", label: "האם יש לך בעיות לב?" },
	{ key: "hasWeaponLicense", label: "האם יש לך רישיון נשק?" },
	{ key: "hasTransporters", label: "האם יש לך משנעים מורשים?" },
];

export const MedicalQuestions: React.FC<MedicalQuestionsProps> = ({ questionnaire }) => {
	return (
		<div className="grid grid-cols-1 gap-4">
			{questions.map((question) => (
				<div
					key={question.key}
					className="flex flex-wrap justify-between items-center p-3 bg-content2 rounded-medium"
				>
					<span className="font-medium mb-2 text-sm text-start sm:mb-0 w-full sm:w-auto">
						{question.label}
					</span>
					<YesNoChip value={questionnaire[question.key] as any} />
				</div>
			))}
		</div>
	);
};

interface YesNoChipProps {
	value?: boolean;
}

const YesNoChip: React.FC<YesNoChipProps> = ({ value }) => {
	return value ? (
		<Chip
			color="success"
			variant="flat"
			startContent={<Icon icon="lucide:check" className="h-4 w-4" />}
		>
			כן
		</Chip>
	) : (
		<Chip
			color="danger"
			variant="flat"
			startContent={<Icon icon="lucide:x" className="h-4 w-4" />}
		>
			לא
		</Chip>
	);
};
